export default "__VITE_ASSET__CN$VR0S4__"